<template>
  <div id="repair">
    <section class="sec1">
      <p class="p-h5">验收部位：{{this.$route.params.checkProjectName}}--{{this.$route.params.houseTypeName}}</p>
    </section>
    <section class="sec2">
      <p class="p-h5">问题描述：</p>
      <div>
        <textarea maxlength="100" id="content" autofocus v-model="repairContent" cols="50" rows="5" placeholder="请描述问题内容"></textarea>
      </div>
    </section>
    <section class="sec3">
      <p class="p-h5">添加照片：</p>
      <div>
        <ul>
          <li v-for="(src,index) in files">
            <img class='preview' :src="src">
            <img class="close" @click="close(index)" src="../../../../static/img/closea.png">
          </li>
          <li>
            <input type='file' name="doc" ref="choose" accept="image/*" id="doc"  @change='setImagePreview($event)' hidden/>
            <img class="add-baoxiu" @click="chooseImg" v-if="this.files.length<4" src="../../../../static/img/add-baoxiu.png">
          </li>
        </ul>
      </div>
    </section>
    <footer class="sec5">
      <input type="button"class="btn" @click="btn" value="我要上报">
    </footer>
    <img id='loading' src="../../../../static/img/loading2.gif" v-if="isDisplay"  />
  </div>
</template>
<script>
  import oSelect from '../../Son/select'
  export default{
    name:"repair",
    components: {
      'oSelect':oSelect, //注册组件
    },
    data () {
      return {
        files:[],   //报修图片的src
        file: [],   //报修图片
        repairContent: '',   //上报内容
        isclicked:0,
        cilck_btn:false,
        showImg:false,
        imgSrc: '',
        isDisplay:false//默认不显示loading图
      }
    },
    mounted () {

    },
    methods: {
      clickImg(e) {
        this.showImg = true;
        // 获取当前图片地址
        this.imgSrc = e.currentTarget.src;
      },
      btn () {
        const _this = this
        if(!this.isDisable){
          if(!this.repairContent){
            alert('请填写信息')
          }else{
            if(!this.click_btn){
              this.click_btn = true
              //显示loading图
              this.isDisplay = true
              let formData = new FormData();
              for(let i=0;i<this.file.length;i++){
                formData.append('files',this.file[i])
                console.log(this.file[i])
              }
              formData.append('pkInspection',this.$route.params.pkInspection)//验房单
              formData.append('pkInspectionRecord',this.$route.params.pkInspectionRecord)//验房记录
              formData.append('pkCheckProject',this.$route.params.pkCheckProject)//验房项目
              formData.append('pkHouseType',this.$route.params.pkHouseType)//房间类型
              formData.append('accountCode',this.$route.params.accountCode)//帐套
              formData.append('problem',this.repairContent)
              formData.append('pkHouse',this.$route.params.pkHouse)
              this.uploadFileRequestN9(this.$route.params.sysUrl+'/LsInterfaceServer/phoneServer/wechat/submitReformBillAction', formData)
                .then(data => {
                  _this.click_btn = false
                  if (data.data.StateCode === 0) {
                    //隐藏loading图
                    _this.isDisplay=false
                    alert('提交成功')
                    _this.$router.push({name:'mobileHomeInspection'})
                  }else if(data.data.StateCode === 4){
                    alert(data.data.ErrorMsg)
                  }else{
                    alert('网络异常')
                  }
                }).catch( res => {
                _this.click_btn = false
              })
            }

          }
        }else{
          alert('请勿频繁点击')
        }
      },
      chooseImg () {
        this.$refs.choose.click()
      },
      setImagePreview (event) {
        this.file.push(event.target.files[0])
        this.files.push(window.URL.createObjectURL(event.target.files[0]))
        console.log(this.file)
        // let filess = event.target.files || event.dataTransfer.files
        // if (this.files.length === 0) return;
        // this.createImage (filess,event)
      },
      createImage (file, event) {
        let _this = this
        this.lrz(file[0],{
          width:100,
          quality:.5
        }).then(function(rst) {
          _this.file.push(rst.base64)
          return rst;
        }).always(function() {
          event.target.value = null;
        })
      },
      close (val) {
        console.log(val)
        this.files.splice(val,1)
        this.file.splice(val,1)
      }
    }
  }
</script>
<style scoped>
  /*点击上报的时候 显示 loading*/
  #loading{
    position:fixed;
    left:47%;
    top:40%;
    transform: translateY(-50%),translateX(-50%);
  }
  #repair{
    text-align: left;
    padding: 0 26px;
    box-sizing: border-box;
  }
  section{
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 28px;
  }
  .p-h5{
    font-size:34px;
    color:#000;
    margin: 33px 0;
  }
  textarea::-webkit-input-placeholder{ /*WebKit browsers*/
    color: #ccc;
  }
  .sec2 div textarea{
    width:700px;
    height:210px;
    padding: 19px;
    background: #f6f6f6;
    box-sizing: border-box;
    font-size:24px;
    margin-bottom: 38px;
    border-radius:10px;
    box-shadow:4px 2px 6px rgba(228,228,228,0.18);
  }
  .sec3 ul{
    margin-bottom: 36px;
    display: flex;
    justify-content:left;
  }
  .add-baoxiu{
    width: 120px;
    height: 120px;
  }
  .preview{
    width: 130px;
    height: 130px;
  }
  .close{
    width: 35px;
    height: 35px;
    position: relative;
    top: -114px;
    left: -26px;
  }
  .sec5{
    text-align: center;
  }
  .btn{
    margin: 104px 0 60px 0;
    width: 520px;
    height: 80px;
    border-radius: 40px;
    background: -webkit-linear-gradient(left, #FFA650,#F7B932); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right,  #FFA650,#F7B932); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFA650,#F7B932); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right,  #FFA650,#F7B932); /* 标准的语法 */
    font-size: 32px;
    color:#fff;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/pub-component/mobile-home/problem-input.vue